import React, { useEffect } from 'react'
import VehicleTestResultNavigation from '../VehicleTestResultNavigation'
import { FormattedMessage } from 'react-intl'
import { Button, Flex } from 'antd'
import PartNumberLabel from '../PartNumberLabel'
import './style.scss'

export const OverlayButtons = ({
  vehicleTestResultId,
  open,
  openFaultModalHandler,
  hrefParams = null,
  partNumberLabel = null,
}) => {
  useEffect(() => {
    const navigationButtons = document.getElementsByClassName(
      'overlay-navigation-container',
    )
    if (navigationButtons) {
      Array.from(navigationButtons).forEach((navigationButton) => {
        if (open) {
          navigationButton.style.width = 'calc(100% - 278px)'
        } else {
          navigationButton.style.width = '100%'
        }
      })
    }

    const faultButtons = document.getElementsByClassName('add-fault-button')
    if (faultButtons) {
      Array.from(faultButtons).forEach((faultButton) => {
        faultButton.style.right = open ? '298px' : '20px'
      })
    }
  }, [open])

  return (
    <>
      <Flex className="overlay-navigation-container" justify="center">
        <VehicleTestResultNavigation
          vehicleTestResultId={vehicleTestResultId}
          hrefParams={hrefParams}
        />
      </Flex>
      {partNumberLabel && (
        <PartNumberLabel
          partNumber={partNumberLabel}
          dataTestId="graph-part-number-label"
          style={{
            position: 'absolute',
            bottom: 'calc(2% + 40px)',
            right: open ? '298px' : '20px',
          }}
        />
      )}
      <Button
        onClick={openFaultModalHandler}
        data-testid="add-fault-button"
        className="add-fault-button"
      >
        <FormattedMessage id="repairHistory.titles.addFault" />
      </Button>
    </>
  )
}
